module.exports = {
  pageDefaults: {
    padding: '48px 12px',
    width: '1440px',
  },
  colors: {
    fontColor: 'rgba(0, 0, 0, 0.85)',
    brandBlue: '#0D5CAA',
    brandOrange: '#BF5512',
    brandOrangeLight: '#E67E22',
    backgroundGray: '#F0F2F5',
    borderGray: '#d9d9d9',
    backgroundLightGray: '#F5F5F5',
    backgroundColorGray: 'rgb(251, 251, 251)',
    borderDarkGray: '#E8E8E8',
    transparentBlack: 'rgba(0, 0, 0, 0.5)',
    alertRed: '#E32934',
    errorMessageRed: '#CF1322',
    white: '#FFFFFF',
    link: '#B8651B',
  },
};
